import React from 'react';

const PostButton = (props) => {
    const {
        button,
        className
    } = props;

    let buttonTag = <a
        href={button.url}
        className={className}
        target={button.target}
    >
        <span>{button.title}</span>
    </a>

    return buttonTag;
}

export default PostButton;